import {
  View,
  Text,
  KeyboardAvoidingView,
  Platform,
  TouchableWithoutFeedback,
  Keyboard,
} from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  hideBottomNavigation,
  showBackButton,
  showBackButtonWithFunction,
  showBottomNavigation,
} from "../../redux/header/headerAction";
import { lighterBlue, primary, white } from "../../colors";
import SelectChildrenMini from "../../components/custom/SelectChildrenMini";
import DoctorChatDetail from "../../components/consultation/DoctorChatDetail";
import ChatInput from "../../components/consultation/ChatInput";
import VoiceMessage from "../../components/consultation/chatMessage/VoiceMessage";
import TextMessage from "../../components/consultation/chatMessage/TextMessage";
import ImageMessage from "../../components/consultation/chatMessage/ImageMessage";
import { FlatList } from "react-native-gesture-handler";
import detailConsultationUser from "../../api/consultation/detailConsultationUser";
import getChatMessages from "../../api/consultation/getChatMessages";
import { io } from "socket.io-client";
import getToken from "../../api/token";
import getMessages from "../../api/support/getMessages";
import SupportChatInput from "../../components/consultation/SupportChatInput";
import MyText from "../../components/custom/MyText";
import { AntDesign } from "@expo/vector-icons";
import translate from "../../functions/translate";
import SupportTimeItem from "../../components/custom/SupportTimeItem";
import responseDayList from "../../api/consultation/responseDayList";
import MyButton from "../../components/custom/MyButton";
import setResponseDay from "../../api/consultation/setResponseDay";
import MyInputWithLabel from "../../components/custom/MyInputWithLabel";
import maxConsultation from "../../api/consultation/maxConsultation";
import setMaxConsultation from "../../api/consultation/setMaxConsultation";
import Checkbox from "expo-checkbox";
import isCounselingActive from "../../api/consultation/isCounselingActive";
import changeCounselingActivation from "../../api/consultation/changeCounselingActivation";

export default function SupportTime({ route }) {
  const [isChecked, setChecked] = useState();
  const [info, setInfo] = useState({
    maxConsultation: "",
  });
  useEffect(() => {
    isCounselingActive().then(({ data }) => {

      if (data.status === 200) {
        setChecked(data.data !== "notActive");
      }
    });
    maxConsultation().then(({ data }) => {
      if (data.status === 200) {
        setInfo((prev) => {
          let newObj = prev;
          newObj["maxConsultation"] = data.data;
          return { ...newObj };
        });
      }
    });
  }, []);
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const isFocused = useIsFocused();
  const dayList = [
    "شنبه",
    "یک شنبه",
    "دو شنبه",
    "سه شنبه",
    "چهار شنبه",
    "پنج شنبه",
    "جمعه",
  ];

  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#fcfcfc"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
    return () => {};
  }, [isFocused]);

  const [doctorDays, setDoctorDays] = useState({});
  const [newDoctorDays, setNewDoctorDays] = useState({});

  useEffect(() => {
    changeCounselingActivation(isChecked ? "active" : "deactive");
  }, [isChecked]);

  useEffect(() => {
    responseDayList().then(({ data }) => {
      if (data.status === 200) {
        dayList.map((day) => {
          let todayTime = data.data.filter((dayData) => dayData.dayName == day);
          if (todayTime.length > 0) {
            todayTime = todayTime[0];
            setDoctorDays((prev) => {
              let newObj = prev;
              newObj[day] = todayTime.time;

              return { ...newObj };
            });
          } else {
            setDoctorDays((prev) => {
              let newObj = prev;
              newObj[day] = undefined;

              return { ...newObj };
            });
          }
        });
      }
    });
  }, []);

  const saveChanges = () => {
    Object.keys(doctorDays).map((day, index) => {
      setResponseDay(
        day,
        newDoctorDays[day].start,
        newDoctorDays[day].end
      ).then((response) => {});

    });

    setMaxConsultation(
      info.maxConsultation === undefined ||
        info.maxConsultation === null ||
        info.maxConsultation.length === 0
        ? 100
        : +info.maxConsultation
    ).then((response) => {});
    setTimeout(() => {
      navigation.goBack();
    }, 500);
  };

  return (
    <View style={{ flex: 1 }}>
      <KeyboardAwareScrollView enableOnAndroid extraHeight={100}>
        <View style={{}}>
          <View
            style={{
              backgroundColor: "#fff",
              width: "100%",
              alignItems: "center",
              flex: 1,
              paddingBottom: Platform.OS !== "web" ? 30 : 0,
            }}
          >
            <View
              style={{
                width: "95%",
                backgroundColor: "#eeeeee",
                padding: 10,
                marginVertical: 10,
                borderRadius: 5,
              }}
            >
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <View>
                  <AntDesign name="clockcircleo" size={35} color={primary} />
                </View>
                <MyText style={{ marginHorizontal: 10, fontSize: 18 }}>
                  {translate("support time")}
                </MyText>
              </View>
            </View>
            <View style={{ width: "100%", alignItems: "center" }}>
              <View
                style={{
                  width: "95%",
                  padding: 10,
                  borderRadius: 10,
                  backgroundColor: "#fafafa",
                  borderWidth: 1,
                  borderColor: "#eeeeee",
                }}
              >
                <View style={{ marginVertical: 5 }}>
                  <MyText style={{ fontSize: 16 }}>
                    سقف مجاز مشاوره های فعال
                  </MyText>
                  <View
                    style={{
                      flexDirection: "row",
                      marginVertical: 10,
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      value={isChecked}
                      onValueChange={setChecked}
                      color={isChecked ? primary : undefined}
                    />
                    <MyText
                      style={{
                        fontSize: 12,
                        marginHorizontal: 5,
                      }}
                    >
                      امکان شروع مشاوره جدید فعال باشد
                    </MyText>
                  </View>
                </View>

                <View>
                  <MyText style={{ fontSize: 16 }}>
                    سقف مجاز مشاوره های فعال
                  </MyText>
                  <MyText style={{ fontSize: 10 }}>
                    با تعیین سقف پس از این که تعداد مشاوره های فعال به سقف مشخص
                    شده رسید دیگر کاربران نمی توانند برای شما درخواست مشاوره ثبت
                    کنند
                  </MyText>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    marginTop: 10,
                    alignItems: "center",
                  }}
                >
                  <MyText>تعداد سقف مجاز</MyText>
                  <View style={{ width: 80, marginHorizontal: 10 }}>
                    <MyInputWithLabel
                      keyboardType="number-pad"
                      name="maxConsultation"
                      disabled={false}
                      value={info.maxConsultation}
                      setInput={setInfo}
                    />
                  </View>
                </View>
                <MyText style={{ fontSize: 10 }}>
                  در صورتی که این قسمت را خالی بگذارید سقفی برای شما در نظر
                  گرفته نمیشود.
                </MyText>
              </View>
            </View>

            <View style={{ flex: 1, width: "100%", alignItems: "center" }}>
              {Object.keys(doctorDays).map((item) => (
                <SupportTimeItem
                  setTime={setNewDoctorDays}
                  day={item}
                  time={doctorDays[item]}
                  key={item}
                />
              ))}
            </View>
          </View>
        </View>
        <View style={{ height: 140 }}></View>
      </KeyboardAwareScrollView>
      <View
        style={{
          flex: 1,
          width: "100%",
          alignItems: "center",
          position: "absolute",
          bottom: 100,
        }}
      >
        <MyButton text="ذخیره تغییرات" onPress={saveChanges} />
      </View>
    </View>
  );
}
